import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './index.less';
import warningToast from '../../assets/warningToast.png'

interface SignInToastProps {
  content: string;
  visible: boolean;
  onClose: () => void;
  duration?: number;
}

const SignInToast: React.FC<SignInToastProps> = ({ content, visible, onClose, duration = 2000 }) => {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [visible, onClose, duration]);

  if (!visible) return null;

  return (
    <div className={styles['signInToastContainer']}>
      <img src={warningToast} className={styles['signInToastIcon']} alt="" />
      <span className={styles['signInToastContent']}>{content}</span>
    </div>
  );
};

// Toast管理器
class ToastManager {
  private static instance: ToastManager;
  private containers: HTMLElement[] = [];

  static getInstance(): ToastManager {
    if (!ToastManager.instance) {
      ToastManager.instance = new ToastManager();
    }
    return ToastManager.instance;
  }

  private createContainer(): HTMLElement {
    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.top = '0';
    container.style.left = '0';
    container.style.width = '100%';
    container.style.height = '100%';
    container.style.pointerEvents = 'none';
    container.style.zIndex = '9999';
    document.body.appendChild(container);
    
    // 将新容器添加到数组中
    this.containers.push(container);
    
    return container;
  }

  warning(content: string, duration: number = 2000): void {
    const container = this.createContainer();
    
    const ToastComponent = () => {
      const [visible, setVisible] = useState(true);
      
      const handleClose = () => {
        setVisible(false);
        setTimeout(() => {
          if (container && container.parentNode) {
            container.parentNode.removeChild(container);
            // 从数组中移除已关闭的容器
            const index = this.containers.indexOf(container);
            if (index > -1) {
              this.containers.splice(index, 1);
            }
          }
        }, 300); // 等待动画完成
      };

      return (
        <SignInToast 
          content={content} 
          visible={visible} 
          onClose={handleClose} 
          duration={duration}
        />
      );
    };

    ReactDOM.render(<ToastComponent />, container);
  }
}

// 导出静态方法
export const showToast = (content: string, duration?: number) => {
  ToastManager.getInstance().warning(content, duration || 2000);
};

export default showToast;